(function () {
  "use strict";

  document.documentElement.classList.remove("cl-no-js");

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function reveal() {
    var items = document.querySelectorAll(".cl-reveal");
    if (!items.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add("is-visible");
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
    );
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function currencyCode() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return "USD";
  }

  function money(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) return "";
    var code = currencyCode();
    var amount = n.toFixed(2);
    if (code === "USD") return "$" + amount + " USD";
    return amount + " " + code;
  }

  function normalisePath(url) {
    if (!url) return "";
    return url.split("?")[0];
  }

  function highlight(text, query) {
    var frag = document.createDocumentFragment();
    var source = String(text == null ? "" : text);
    var q = String(query || "").trim();
    if (!q) {
      frag.appendChild(document.createTextNode(source));
      return frag;
    }
    var haystack = source.toLowerCase();
    var terms = q.toLowerCase().split(/\s+/).filter(function (t) {
      return t.length > 1;
    });
    if (!terms.length) terms = [q.toLowerCase()];

    var marks = [];
    terms.forEach(function (term) {
      var from = 0;
      var at;
      while ((at = haystack.indexOf(term, from)) !== -1) {
        marks.push([at, at + term.length]);
        from = at + term.length;
      }
    });
    if (!marks.length) {
      frag.appendChild(document.createTextNode(source));
      return frag;
    }
    marks.sort(function (a, b) {
      return a[0] - b[0];
    });
    var merged = [marks[0]];
    for (var i = 1; i < marks.length; i++) {
      var last = merged[merged.length - 1];
      if (marks[i][0] <= last[1]) last[1] = Math.max(last[1], marks[i][1]);
      else merged.push(marks[i]);
    }
    var cursor = 0;
    merged.forEach(function (span) {
      if (span[0] > cursor) frag.appendChild(document.createTextNode(source.slice(cursor, span[0])));
      var mark = document.createElement("mark");
      mark.textContent = source.slice(span[0], span[1]);
      frag.appendChild(mark);
      cursor = span[1];
    });
    if (cursor < source.length) frag.appendChild(document.createTextNode(source.slice(cursor)));
    return frag;
  }

  function makeIcon(pathData) {
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    var p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", pathData);
    svg.appendChild(p);
    return svg;
  }

  var ARROW = "M5 12h14M13 6l6 6-6 6";

  function Search(root) {
    this.form = root;
    this.input = root.querySelector("[data-cl-input]");
    this.panel = root.querySelector("[data-cl-panel]");
    this.live = root.querySelector("[data-cl-live]");
    this.clearBtn = root.querySelector("[data-cl-clear]");
    if (!this.input || !this.panel) return;

    this.cache = new Map();
    this.results = [];
    this.activeIndex = -1;
    this.controller = null;
    this.timer = null;
    this.indexPromise = null;
    this.open = false;
    this.lastQuery = "";
    this.focused = false;

    var host = window.location.hostname;
    this.sameOrigin = /(^|\.)chadlawson\.com$/i.test(host);
    this.endpoint = this.sameOrigin
      ? "/search/suggest.json"
      : "https://www.chadlawson.com/search/suggest.json";
    var enabled = this.form.getAttribute("data-cl-live-enabled");
    this.useLive =
      (enabled === null || enabled === "true") &&
      (this.sameOrigin || this.form.getAttribute("data-cl-live") === "true");
    var indexSrc = this.form.getAttribute("data-cl-index");
    this.indexSrc = indexSrc === null ? "assets/data/search-index.js" : indexSrc;

    this.renderShell();
    this.bind();
  }

  Search.prototype.renderShell = function () {
    var listboxId = this.input.getAttribute("aria-controls") || "cl-search-listbox";
    this.listbox = document.createElement("div");
    this.listbox.setAttribute("role", "listbox");
    this.listbox.setAttribute("id", listboxId);
    this.listbox.setAttribute("aria-label", "Search results");
    this.panel.appendChild(this.listbox);
  };

  Search.prototype.bind = function () {
    var self = this;
    var field = this.form.querySelector("[data-cl-field]");

    this.input.addEventListener("input", function () {
      self.onInput();
    });

    this.input.addEventListener("focus", function () {
      self.focused = true;
      self.form.classList.add("is-active");
      self.syncFloat();
      if (self.input.value.trim().length >= 2) self.onInput(true);
      else if (self.lastQuery) self.onInput(true);
    });

    this.input.addEventListener("blur", function () {
      self.focused = false;
      self.form.classList.remove("is-active");
      self.syncFloat();
    });

    if (field) {
      field.addEventListener("mousedown", function (event) {
        if (event.target === self.input) return;
        if (event.target.closest && event.target.closest("[data-cl-clear]")) return;
        event.preventDefault();
        self.input.focus();
      });
    }

    this.input.addEventListener("keydown", function (event) {
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        if (!self.open && self.results.length) {
          self.showPanel();
          event.preventDefault();
          return;
        }
        if (!self.open) return;
        event.preventDefault();
        self.move(event.key === "ArrowDown" ? 1 : -1);
        return;
      }
      if (event.key === "Enter") {
        if (self.open && self.activeIndex > -1) {
          event.preventDefault();
          self.go(self.results[self.activeIndex]);
        }
        return;
      }
      if (event.key === "Escape") {
        if (self.open) {
          event.preventDefault();
          self.close(true);
        }
        return;
      }
      if (event.key === "Home" && self.open) {
        event.preventDefault();
        self.setActive(0);
        return;
      }
      if (event.key === "End" && self.open) {
        event.preventDefault();
        self.setActive(self.results.length - 1);
      }
    });

    this.clearBtn.addEventListener("click", function () {
      self.input.value = "";
      self.input.focus();
      self.syncFloat();
      self.lastQuery = "";
      self.results = [];
      self.close(false);
      self.announce("Search cleared.");
    });

    this.form.addEventListener("submit", function () {
      self.close(false);
    });

    document.addEventListener("click", function (event) {
      if (!self.form.contains(event.target)) self.close(false);
    });

    this.form.addEventListener("focusout", function (event) {
      if (event.relatedTarget && !self.form.contains(event.relatedTarget)) self.close(false);
    });

    this.panel.addEventListener("mousemove", function (event) {
      var option = event.target.closest ? event.target.closest("[data-cl-option]") : null;
      if (!option) return;
      var idx = self.results.findIndex(function (r) {
        return r.id === option.id;
      });
      if (idx > -1) self.setActive(idx);
    });
  };

  Search.prototype.announce = function (message) {
    if (this.live) this.live.textContent = message;
  };

  Search.prototype.syncFloat = function () {
    var filled = this.input.value.length > 0;
    this.form.classList.toggle("is-filled", filled);
    this.form.classList.toggle("is-floated", filled || this.focused === true);
  };

  Search.prototype.onInput = function (immediate) {
    var self = this;
    var value = this.input.value.trim();

    this.syncFloat();

    if (this.timer) window.clearTimeout(this.timer);

    if (value.length < 2) {
      this.results = [];
      this.close(false);
      this.announce(value.length ? "Keep typing to search." : "");
      return;
    }

    this.form.classList.add("is-loading");
    this.timer = window.setTimeout(
      function () {
        self.run(value);
      },
      immediate ? 0 : 190
    );
  };

  Search.prototype.run = function (query) {
    var self = this;

    if (this.cache.has(query)) {
      this.form.classList.remove("is-loading");
      this.ready(query, this.cache.get(query));
      return;
    }

    if (this.controller) this.controller.abort();
    var controller = typeof AbortController !== "undefined" ? new AbortController() : null;
    this.controller = controller;

    var primary = this.useLive
      ? this.fetchLive(query, controller)
      : Promise.reject(new Error("local mode"));

    primary
      .then(function (data) {
        self.cache.set(query, data);
        self.form.classList.remove("is-loading");
        self.ready(query, data);
      })
      .catch(function () {
        return self.fetchFallback().then(function (data) {
          var results = self.searchLocal(query, data);
          self.cache.set(query, results);
          self.form.classList.remove("is-loading");
          self.ready(query, results);
        });
      })
      .catch(function () {
        self.form.classList.remove("is-loading");
        self.error(query);
      });
  };

  Search.prototype.fetchLive = function (query, controller) {
    var url =
      this.endpoint +
      "?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product,collection,page,article" +
      "&resources[limit]=6" +
      "&resources[options][unavailable_products]=last";

    var options = { credentials: this.sameOrigin ? "same-origin" : "omit" };
    if (controller) options.signal = controller.signal;

    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error("search unavailable");
      return response.json();
    }).then(function (payload) {
      var out = [];
      var buckets = (payload && payload.resources && payload.resources.results) || {};
      appendBucket(out, buckets.products, "product", "Product");
      appendBucket(out, buckets.collections, "collection", "Collection");
      appendBucket(out, buckets.pages, "page", "Page");
      return out;
    });
  };

  function appendBucket(out, list, kind, label) {
    (list || []).forEach(function (item) {
      var image = item.image || (item.featured_image && item.featured_image.url) || "";
      var price = item.price || "";
      var meta = label;
      if (kind === "product") {
        if (item.type) meta = item.type;
        else if (item.vendor) meta = item.vendor;
      } else if (kind === "collection") {
        meta = typeof item.products_count === "number" ? item.products_count + " products" : "Collection";
      }
      out.push({
        title: item.title || "",
        url: normalisePath(item.url),
        kind: kind,
        meta: meta,
        price: kind === "product" ? money(price) : "",
        image: image ? image.split("?")[0] + "?width=140" : "",
        available: item.available !== false,
      });
    });
  }

  Search.prototype.fetchFallback = function () {
    var self = this;
    if (window.CL_SEARCH_INDEX) return Promise.resolve(window.CL_SEARCH_INDEX);
    if (this.indexPromise) return this.indexPromise;
    if (!this.indexSrc) return Promise.reject(new Error("no index configured"));

    this.indexPromise = new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = self.indexSrc;
      script.onload = function () {
        if (window.CL_SEARCH_INDEX) resolve(window.CL_SEARCH_INDEX);
        else reject(new Error("index empty"));
      };
      script.onerror = function () {
        reject(new Error("index unavailable"));
      };
      document.head.appendChild(script);
    });
    return this.indexPromise;
  };

  Search.prototype.searchLocal = function (query, data) {
    var terms = query.toLowerCase().split(/\s+/).filter(Boolean);
    function score(text) {
      var value = String(text || "").toLowerCase();
      var total = 0;
      for (var i = 0; i < terms.length; i++) {
        var at = value.indexOf(terms[i]);
        if (at === -1) return -1;
        total += at === 0 ? 40 : value.charAt(at - 1) === " " ? 24 : 10;
        total -= value.length * 0.02;
      }
      return total;
    }
    function rank(list, kind, limit) {
      return list
        .map(function (item) {
          var haystack = item.t + " " + (item.y || "") + " " + (item.g || "");
          return { item: item, s: score(haystack) };
        })
        .filter(function (row) {
          return row.s >= 0;
        })
        .sort(function (a, b) {
          return b.s - a.s;
        })
        .slice(0, limit)
        .map(function (row) {
          var item = row.item;
          return {
            title: item.t,
            url: item.u,
            kind: kind,
            meta: kind === "product" ? item.y || "Product" : kind === "collection" ? item.n + " products" : "Page",
            price: kind === "product" ? money(item.p) : "",
            image: kind === "product" ? item.i : "",
            available: item.a !== false,
          };
        });
    }
    return rank(data.products || [], "product", 7)
      .concat(rank(data.collections || [], "collection", 4))
      .concat(rank(data.pages || [], "page", 3));
  };

  Search.prototype.error = function (query) {
    this.results = [];
    this.listbox.textContent = "";
    this.listbox.hidden = true;
    this.clearStatusBlock();
    var wrap = document.createElement("div");
    wrap.className = "cl-panel__empty";
    wrap.setAttribute("data-cl-status", "");
    var title = document.createElement("p");
    title.className = "cl-panel__empty-title";
    title.textContent = "Search is unavailable right now";
    var text = document.createElement("p");
    text.className = "cl-panel__empty-text";
    var link = document.createElement("a");
    link.href = "/search?q=" + encodeURIComponent(query);
    link.textContent = "Browse all results instead";
    text.appendChild(link);
    wrap.appendChild(title);
    wrap.appendChild(text);
    this.panel.insertBefore(wrap, this.panel.firstChild);
    this.setFooter(query, 0);
    this.showPanel();
    this.announce("Search is unavailable.");
  };

  Search.prototype.clearStatusBlock = function () {
    var existing = this.panel.querySelector("[data-cl-status]");
    if (existing) existing.remove();
  };

  Search.prototype.ready = function (query, results) {
    this.results = results || [];
    this.activeIndex = -1;
    this.listbox.textContent = "";
    this.clearStatusBlock();

    if (!this.results.length) {
      this.listbox.hidden = true;
      var wrap = document.createElement("div");
      wrap.className = "cl-panel__empty";
      wrap.setAttribute("data-cl-status", "");
      var title = document.createElement("p");
      title.className = "cl-panel__empty-title";
      title.textContent = "No matches for \u201c" + query + "\u201d";
      var text = document.createElement("p");
      text.className = "cl-panel__empty-text";
      text.textContent = "Try a song or album title, or browse the categories below.";
      wrap.appendChild(title);
      wrap.appendChild(text);
      this.panel.insertBefore(wrap, this.panel.firstChild);
      this.setFooter(query, 0);
      this.showPanel();
      this.announce("No results found.");
      return;
    }

    this.listbox.hidden = false;

    var groups = [
      { key: "product", label: "Products" },
      { key: "collection", label: "Collections" },
      { key: "page", label: "Pages" },
    ];
    var index = 0;
    var self = this;

    groups.forEach(function (group) {
      var rows = self.results.filter(function (r) {
        return r.kind === group.key;
      });
      if (!rows.length) return;

      var section = document.createElement("div");
      section.className = "cl-panel__group";
      section.setAttribute("role", "group");
      section.setAttribute("aria-label", group.label);

      var heading = document.createElement("p");
      heading.className = "cl-panel__heading";
      heading.setAttribute("aria-hidden", "true");
      heading.textContent = group.label;
      section.appendChild(heading);

      var list = document.createElement("div");
      list.className = "cl-panel__list";

      rows.forEach(function (row) {
        list.appendChild(self.buildOption(row, index, query));
        index++;
      });

      section.appendChild(list);
      self.listbox.appendChild(section);
    });

    this.setFooter(query, this.results.length);
    this.showPanel();
    this.announce(this.results.length + (this.results.length === 1 ? " result" : " results") + " available.");
  };

  Search.prototype.buildOption = function (row, index, query) {
    var self = this;
    var option = document.createElement("a");
    option.className = "cl-result";
    option.id = "cl-opt-" + index;
    option.href = row.url || "/search?q=" + encodeURIComponent(query);
    option.setAttribute("role", "option");
    option.setAttribute("aria-selected", "false");
    option.setAttribute("data-cl-option", "");
    option.style.setProperty("--i", String(Math.min(index, 10)));

    var media = document.createElement("span");
    media.className = "cl-result__media";
    if (row.image) {
      var img = document.createElement("img");
      img.src = row.image;
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";
      img.width = 48;
      img.height = 48;
      media.appendChild(img);
    } else {
      media.classList.add("cl-result__media--icon");
      media.appendChild(makeIcon(row.kind === "collection" ? "M4 6h16M4 12h16M4 18h10" : "M7 3h7l5 5v13H7z"));
    }

    var body = document.createElement("span");
    body.className = "cl-result__body";
    var title = document.createElement("span");
    title.className = "cl-result__title";
    title.appendChild(highlight(row.title, query));
    var meta = document.createElement("span");
    meta.className = "cl-result__meta";
    meta.textContent = row.meta + (row.available === false ? " \u00b7 Sold out" : "");
    body.appendChild(title);
    body.appendChild(meta);

    var price = document.createElement("span");
    price.className = "cl-result__price";
    price.textContent = row.price;

    var arrow = document.createElement("span");
    arrow.className = "cl-result__arrow";
    arrow.appendChild(makeIcon(ARROW));

    option.appendChild(media);
    option.appendChild(body);
    if (row.price) option.appendChild(price);
    option.appendChild(arrow);

    option.addEventListener("mouseenter", function () {
      self.setActive(index);
    });

    return option;
  };

  Search.prototype.setFooter = function (query, count) {
    var existing = this.panel.querySelector(".cl-panel__footer");
    if (existing) existing.remove();
    var footer = document.createElement("a");
    footer.className = "cl-panel__footer";
    footer.href = "/search?q=" + encodeURIComponent(query);
    var label = document.createElement("span");
    label.textContent = count
      ? "View all results for \u201c" + query + "\u201d"
      : "Search all products for \u201c" + query + "\u201d";
    var hint = document.createElement("kbd");
    hint.textContent = "Enter";
    footer.appendChild(label);
    footer.appendChild(hint);
    this.panel.appendChild(footer);
  };

  Search.prototype.showPanel = function () {
    if (this.open) return;
    this.open = true;
    this.panel.hidden = false;
    this.form.classList.add("is-open");
    this.input.setAttribute("aria-expanded", "true");
  };

  Search.prototype.close = function (keepResults) {
    if (!this.open) return;
    this.open = false;
    this.form.classList.remove("is-open");
    this.input.setAttribute("aria-expanded", "false");
    this.input.removeAttribute("aria-activedescendant");
    this.activeIndex = -1;
    if (!keepResults) {
      this.panel.hidden = true;
    } else {
      this.panel.hidden = true;
    }
  };

  Search.prototype.setActive = function (index) {
    if (index === this.activeIndex) return;
    var options = this.listbox.querySelectorAll("[data-cl-option]");
    if (this.activeIndex > -1 && options[this.activeIndex]) {
      options[this.activeIndex].classList.remove("is-active");
      options[this.activeIndex].setAttribute("aria-selected", "false");
    }
    this.activeIndex = index;
    if (index > -1 && options[index]) {
      var el = options[index];
      el.classList.add("is-active");
      el.setAttribute("aria-selected", "true");
      this.input.setAttribute("aria-activedescendant", el.id);
      var panelRect = this.panel.getBoundingClientRect();
      var elRect = el.getBoundingClientRect();
      if (elRect.top < panelRect.top) this.panel.scrollTop -= panelRect.top - elRect.top + 8;
      else if (elRect.bottom > panelRect.bottom) this.panel.scrollTop += elRect.bottom - panelRect.bottom + 8;
    } else {
      this.input.removeAttribute("aria-activedescendant");
    }
  };

  Search.prototype.move = function (delta) {
    var total = this.results.length;
    if (!total) return;
    var next = this.activeIndex + delta;
    if (next < 0) next = total - 1;
    if (next >= total) next = 0;
    this.setActive(next);
  };

  Search.prototype.go = function (row) {
    if (!row) return;
    window.location.href = row.url || "/search";
  };

  function init() {
    reveal();
    var forms = document.querySelectorAll("[data-cl-search]");
    for (var i = 0; i < forms.length; i++) new Search(forms[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
